import { render, staticRenderFns } from "./quick-audit.vue?vue&type=template&id=33e488db&scoped=true"
import script from "./quick-audit.vue?vue&type=script&lang=js"
export * from "./quick-audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e488db",
  null
  
)

export default component.exports